module.exports = __webpack_public_path__ + "static/center.8bb0210316819526b409670f3f987c67.svg";